import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { change } from 'redux-form';

import Button from 'react-bootstrap/lib/Button';

import Field from 'redux-form/lib/Field';
import reduxForm from 'redux-form/lib/reduxForm';
import formValueSelector from 'redux-form/lib/formValueSelector';

import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import CustomConfirmModal from '../../Common/CustomConfirmModal/CustomConfirmModal';

import messages from '../../../locale/jsonMessages';

import submit from './submit'
import validate from './validate';
import Recaptcha from './Recaptcha';

import cp from '../../commonStyle.css';
import s from './ConfigSettingsForm.css';


function ConfigSettingsForm(props) {

  const { error, handleSubmit, submitting, intl: { formatMessage }, autoClaimPayout, autoPayout } = props;

  const dispatch = useDispatch();
  const [ShowModal, setShowModal] = useState(null);
  const [loading, setLoading] = useState(false);

  const prevAutoClaimPayoutRef = useRef();
  const prevAutoPayoutRef = useRef();

  useEffect(() => {
    if (prevAutoClaimPayoutRef.current === "false" && autoClaimPayout === "true") {
      setShowModal("isAutoClaimPayoutModal");
    }
    if (prevAutoPayoutRef.current === "false" && autoPayout === "true") {
      setShowModal("isAutoPayoutModal");
    }

    prevAutoClaimPayoutRef.current = autoClaimPayout;
    prevAutoPayoutRef.current = autoPayout;
  }, [autoClaimPayout, autoPayout]);


  const handleCancelModal = () => {
    if (ShowModal === "isAutoClaimPayoutModal") {
      dispatch(change('ConfigSettingsForm', 'autoClaimPayout', 'false'));
    }
    if (ShowModal === "isAutoPayoutModal") {
      dispatch(change('ConfigSettingsForm', 'autoPayout', 'false'));
    }
    setShowModal(null);
  };

  const handleConfirmModal = () => {
    setLoading(true);
    setShowModal(null);
    setLoading(false);
  };

  const autoCronValue = [
    { value: "true", label: formatMessage(messages.enableLabel) },
    { value: "false", label: formatMessage(messages.disableLabel) }
  ];
  return (
    <div>
      <h1 className='siteAdminHeading'><FormattedMessage  {...messages.manageSiteConfig} /></h1>
      {ShowModal && <CustomConfirmModal
        showModel={ShowModal ? true : false}
        title={formatMessage(messages.autoCronModalTitle)}
        closeModal={handleCancelModal}
        popupButtonLeftName={formatMessage(messages.cancel)}
        popupButtonLeftFunction={handleCancelModal}
        loaderActionBtnText={formatMessage(messages.confirmLabel)}
        loaderConfirmActionFunction={handleConfirmModal}
        load={loading}
      >
        {ShowModal === 'isAutoPayoutModal' ? <div>
          <div className={cx(cp.commonSmallText16, cp.spaceBottom2)}>{formatMessage(messages.autoPayoutModalMessage01)}</div>
          <div className={cp.commonSmallText16}>{formatMessage(messages.autoPayoutModalMessage)}</div>
        </div> :
          <div>
            <div className={cx(cp.commonSmallText16, cp.spaceBottom2)}>{formatMessage(messages.autoClaimModalMessage01)}</div>
            <div className={cp.commonSmallText16}>{formatMessage(messages.autoClaimModalMessage)}</div>
          </div>}
      </CustomConfirmModal>}

      <form onSubmit={handleSubmit(submit)}>
        {error && <strong>{error}</strong>}
        <h5 className='siteAdminSubHeading'>{formatMessage(messages.phoneNumberFormat)}</h5>
        <div className='twoColumnGrid'>
          <Field
            name="phoneNumberStatus"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.phoneNumberFormat)}
            labelText={formatMessage(messages.phoneNumberFormat)}
            inputClass='commonSelectField'
          >
            <option value={1}>{formatMessage(messages.twilioSMS)}</option>
            <option value={3}>{formatMessage(messages.normalPhoneNumber)}</option>
          </Field>
        </div>
        <div className='twoColumnGrid'>
          <Field
            name="maxUploadSize"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.maxUploadLabel)}
            labelText={formatMessage(messages.maxUploadLabel)}
            inputClass='commonInputField'
            isRequiredInput
            maxLength={6}
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'>{formatMessage(messages.googleSettings)}</h5>
        <div className='twoColumnGrid'>
          <Field
            name="googleClientId"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.googleClientId)}
            labelText={formatMessage(messages.googleClientId)}
            inputClass='commonInputField'
            isRequiredInput
          />

          <Field
            name="googleSecretId"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.googleSecretId)}
            labelText={formatMessage(messages.googleSecretId)}
            inputClass='commonInputField'
            isRequiredInput
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'>{formatMessage(messages.deepLinkSettings)}</h5>
        <div className='twoColumnGrid'>
          <Field
            name="deepLinkBundleId"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.deepLinkBundleId)}
            labelText={formatMessage(messages.deepLinkBundleId)}
            inputClass='commonInputField'
            isRequiredInput
          />

          <Field
            inputClass='commonTextAreaField'
            name="deepLinkContent"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.deepLinkContent)}
            labelText={formatMessage(messages.deepLinkContent)}
            componentClass={"textarea"}
            isRequiredInput
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'>{formatMessage(messages.openaiSettingsLabel)}</h5>
        <div className='twoColumnGrid'>
          <Field
            name="openAiBaseUrl"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.openAIBaseURLLabel)}
            labelText={formatMessage(messages.openAIBaseURLLabel)}
            inputClass='commonInputField'
            isRequiredInput
          />
          <Field
            name="openAiKey"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.openAIKey)}
            placeholder={formatMessage(messages.openAIKey)}
            inputClass='commonInputField'
            isRequiredInput
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'>{formatMessage(messages.pushNotificationSettings)}</h5>
        <div className='twoColumnGrid'>
          <Field
            name="fcmPushNotificationKey"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.fcmPushNotificationKey)}
            labelText={formatMessage(messages.fcmPushNotificationKey)}
            inputClass='commonTextAreaField'
            componentClass={"textarea"}
            isRequiredInput
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'><FormattedMessage  {...messages.googleMapLabel} /></h5>
        <div className='twoColumnGrid'>
          <Field
            name="androidAppMapAPIkey"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.androidAppMapAPIkey)}
            labelText={formatMessage(messages.androidAppMapAPIkey)}
            toolTipText={formatMessage(messages.androidAppMapAPIkeyToolTip)}
            inputClass='commonInputField'
            isRequiredInput
          />

          <Field
            name="iosAppMapAPIkey"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.iOSAppMapAPIkey)}
            placeholder={formatMessage(messages.iOSAppMapAPIkey)}
            toolTipText={formatMessage(messages.iOSAppMapAPIkeyToolTip)}
            inputClass='commonInputField'
            isRequiredInput
          />
        </div>
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'><FormattedMessage  {...messages.webGoogleApiKeys} /></h5>
        <div className='twoColumnGrid'>
          <Field
            name="googleMapBrowserApiKey"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.googleMapBrowserApiKey)}
            inputClass='commonInputField'
            toolTipText={formatMessage(messages.googleMapBrowserApiKeyTooltip)}
            placeholder={formatMessage(messages.googleMapBrowserApiKey)}
            isRequiredInput
          />

          <Field
            name="googleMapServerApiKey"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.googleMapServerApiKey)}
            inputClass='commonInputField'
            toolTipText={formatMessage(messages.googleMapServerApiKeyTooltip)}
            placeholder={formatMessage(messages.googleMapServerApiKey)}
            isRequiredInput
          />
        </div>
        <Recaptcha />
        <hr className={s.divider} />
        <h5 className='siteAdminSubHeading'><FormattedMessage  {...messages.otherSettings} /></h5>
        <div className='twoColumnGrid'>
          <Field
            name="autoClaimPayout"
            type="text"
            component={CommonFormComponent}
            inputClass='commonSelectField'
            labelText={formatMessage(messages.authClaimPayout)}
            toolTipText={formatMessage(messages.authClaimPayoutToolTip)}
          >
            {autoCronValue.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>

          <Field name="autoPayout"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.authPayout)}
            toolTipText={formatMessage(messages.authPayoutToolTip)}
            inputClass='commonSelectField'
          >
            {autoCronValue.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}

          </Field>
          <Field
            name="isPromoCodeEnabled"
            component={CommonFormComponent}
            labelText={formatMessage(messages.isPromoCodeEnabled)}
            inputClass='commonSelectField'
            toolTipText={formatMessage(messages.promoCodeEnableToolTip)}
          >
            {autoCronValue.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
          <Field
            name="isServicePlanEnabled"
            component={CommonFormComponent}
            labelText={formatMessage(messages.manageServicePlanLabel)}
            inputClass='commonSelectField'
            toolTipText={formatMessage(messages.manageServicePlanToolTip)}
          >
            {autoCronValue.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
        </div>
        <div className={cx(s.spaceTop4, 'singleBtnFlexEnd')}>
          <Button className={cp.btnPrimary} type="submit" disabled={submitting} >
            <FormattedMessage  {...messages.save} />
          </Button>
        </div>
      </form>
    </div>
  );
}

ConfigSettingsForm = reduxForm({
  form: 'ConfigSettingsForm',
  validate
})(ConfigSettingsForm);

const selector = formValueSelector('ConfigSettingsForm');

const mapState = (state) => ({
  autoClaimPayout: selector(state, 'autoClaimPayout'),
  autoPayout: selector(state, 'autoPayout'),
});

const mapDispatch = {};

export default injectIntl(withStyles(s, cp)(connect(mapState, mapDispatch)(ConfigSettingsForm)));
